import script from "./MultiSelectOperate.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelectOperate.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelectOperate.vue?vue&type=style&index=0&id=defbd922&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-defbd922"]])

export default __exports__